import './LeadStatsStrip.css';

export default function LeadStatsStrip({ stats, loading, activeFilter, onQuickFilter }) {
  const s = stats || {};

  function handleTileClick(filterKey) {
    if (!onQuickFilter) return;
    onQuickFilter(activeFilter === filterKey ? null : filterKey);
  }

  const tiles = [
    { key: 'callsToday',          icon: '📞', label: 'Calls Today',       value: s.callsToday ?? 0,          filterKey: null },
    { key: 'overdueCount',        icon: '⚠️', label: 'Overdue',           value: s.overdueCount ?? 0,        filterKey: 'overdue', urgent: (s.overdueCount ?? 0) > 0 },
    { key: 'hotLeadCount',        icon: '🔥', label: 'Hot Leads',         value: s.hotLeadCount ?? 0,        filterKey: 'hot',     urgent: (s.hotLeadCount ?? 0) > 0 },
    { key: 'activePipelineCount', icon: '📊', label: 'In Pipeline',       value: s.activePipelineCount ?? 0, filterKey: null },
    { key: 'meetingsThisWeek',    icon: '📅', label: 'Meetings / Week',   value: s.meetingsThisWeek ?? 0,    filterKey: null },
    { key: 'convertedThisMonth',  icon: '✅', label: 'Converted / Month', value: s.convertedThisMonth ?? 0,  filterKey: null },
    { key: 'newThisWeek',         icon: '✨', label: 'New / Week',        value: s.newThisWeek ?? 0,         filterKey: null },
  ];

  return (
    <div className="lss__strip">
      {tiles.map(tile => {
        const isFilter = !!tile.filterKey;
        const isActive = !!tile.filterKey && activeFilter === tile.filterKey;
        const isUrgent = !!tile.urgent && !isActive;

        return (
          <div
            key={tile.key}
            className={[
              'lss__tile',
              isFilter  ? 'lss__tile--filterable' : '',
              isActive  ? 'lss__tile--active'     : '',
              isUrgent  ? 'lss__tile--urgent'     : '',
              loading   ? 'lss__tile--loading'    : '',
            ].filter(Boolean).join(' ')}
            onClick={isFilter ? () => handleTileClick(tile.filterKey) : undefined}
            title={isFilter ? (isActive ? 'Click to clear filter' : `Filter to ${tile.label}`) : undefined}
          >
            {isFilter && (
              <span className={`lss__filter-badge ${isActive ? 'lss__filter-badge--active' : ''}`}>
                {isActive ? '✕' : (
                  <svg viewBox="0 0 10 10" width="9" height="9" fill="currentColor">
                    <path d="M0 1.5h10L6.5 5.5v3.5l-3-1V5.5Z"/>
                  </svg>
                )}
              </span>
            )}
            <span className="lss__tile-icon">{tile.icon}</span>
            <span className="lss__tile-value">{loading ? '—' : tile.value}</span>
            <span className="lss__tile-label">{tile.label}</span>
          </div>
        );
      })}
    </div>
  );
}
